// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"8b90f226","70":"21a9e41e","772":"be631cb9"}[chunkId] + ".chunk.js";
};